import React from 'react';
import { TFunction } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import {
  withAccess,
  withInject,
  errorBoundary,
} from '@piwikpro/platform';
import { Outlet } from '@tanstack/react-router';
import {
  MenuSidebar,
  SplitView,
  withTranslation,
} from '@piwikpro/ui-components';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { ReactRouterLink } from '@piwikpro/router-crate/components';

const mapStateToProps = state => ({
  isUserOwner: state.session.userRole as SessionState['userRole'] === 'OWNER',
  hasPaddleSubscription: Boolean(state.payments.subscription.details),
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  GlobalAppSettings: any
  AuditLog: any
  Title: any
  userPreferences: any
  accessManager: any
  Billing: any
  Domains: any
}

interface Props extends ReduxProps, InjectedProps {
  t: TFunction
}

class Settings extends React.Component<Props> {
  render() {
    const {
      accessManager,
      t,
      Title,
      hasPaddleSubscription,
    } = this.props;

    const menuSidebarConfig: any = {
      listData: [
        {
          section: '',
          links: [
            {
              text: t('platform.accountSettings.title'),
              icon: 'settings',
              navigationPath: '/administration/account/account-settings',
              role: 'OWNER',
            },
            {
              text: t('platform.globalWebsiteSettings.title'),
              icon: 'map',
              navigationPath: '/administration/account/app',
              role: 'OWNER',
            },
            {
              text: t('platform.domains.title'),
              icon: 'web',
              navigationPath: '/administration/account/domains',
              role: 'OWNER',
            },
            {
              text: t('platform.license.title'),
              icon: 'badge',
              navigationPath: '/administration/account/subscription',
              role: 'OWNER',
            },
            ...hasPaddleSubscription ? [
              {
                text: t('platform.billing.title'),
                icon: 'billing',
                navigationPath: '/administration/account/billing',
                role: 'USER',
              },
            ] : [],
            {
              text: t('platform.auditLog.title'),
              icon: 'history',
              navigationPath: '/administration/account/audit-log',
              role: 'OWNER',
            },
          ].filter(tab => accessManager.isGranted({ role: tab.role })),
        },
      ],
      routerLink: ReactRouterLink,
    };

    return (
      <Title part={t('navigation.sections.account')}>
        <SplitView
          leftSidebar={{
            sidebar: <MenuSidebar routerMode="v7" {...menuSidebarConfig} />,
          }}
        >
          <Outlet />
        </SplitView>
      </Title>
    );
  }
}

export default connector(withInject<InjectedProps>({
  GlobalAppSettings: 'TrackerSettingsCrate.components.GlobalAppSettings',
  AuditLog: 'AuditLogCrate.components.AuditLog',
  Title: 'TitleCrate.components.Title',
  userPreferences: 'userPreferences',
  Domains: 'DomainsCrate.components.Domains',
  Billing: 'MarketingCrate.components.Billing',
})(
  withAccess(withTranslation('administration')(errorBoundary(Settings as any))),
));
